const DE_IBAN_REGEX = /^DE\d{20}$/;

/**
 * Validates a German IBAN (22 characters, starting with "DE").
 * Returns `true` if valid, or an error message string otherwise.
 */
export function isValidDeIban(iban: string): true | string {
  const trimmedIban = iban.replace(/\s+/g, "");

  if (trimmedIban.length === 0) {
    return "Bitte geben Sie eine IBAN ein.";
  }

  if (!trimmedIban.startsWith("DE")) {
    return "Derzeit werden nur deutsche IBANs unterstützt. Bitte geben Sie eine gültige deutsche IBAN ein.";
  }

  if (trimmedIban.length !== 22) {
    return `Der eingegebene Wert hat eine Länge von ${trimmedIban.length} Zeichen. Bitte geben Sie eine IBAN mit genau 22 Zeichen ein.`;
  }

  if (!DE_IBAN_REGEX.test(trimmedIban)) {
    return "Die eingegebene IBAN ist ungültig. Bitte überprüfen Sie die IBAN und geben Sie sie erneut ein.";
  }

  return true;
}
